import { render, staticRenderFns } from "./ImagePopupMod.vue?vue&type=template&id=42d45e87&scoped=true"
import script from "./ImagePopupMod.vue?vue&type=script&lang=js"
export * from "./ImagePopupMod.vue?vue&type=script&lang=js"
import style0 from "./ImagePopupMod.vue?vue&type=style&index=0&id=42d45e87&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42d45e87",
  null
  
)

export default component.exports